import request from "@/util/request"

export function getNewsList (data) {
  return request({
    url: "/api/newsList",
    method: "post",
    data,
    params: data,
  })
}
export function getNewsDetail (data) {
  return request({
    url: "/api/newsDetail",
    method: "post",
    data,
    params: data,
  })
}